import { gql } from 'graphql-tag';
import { projectSettingsFragment } from './projectSettingsFragment';

export const UPDATE_PROJECT_SETTINGS_MUTATION = gql`
  mutation UpdateProjectSettings($projectInput: ProjectInput!) {
    updateProject2(projectInput: $projectInput) {
      ...ProjectSettings
    }
  }
  ${projectSettingsFragment}
`;
